import { createFileRoute } from "@tanstack/react-router";

import { AdminOverview } from "@/features/admin";

export const Route = createFileRoute("/_authed/_modal/admin/")({
  component: AdminOverview,
});
